"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const payment_1 = require("../../../model/payment");
const confirm_1 = require("../../../utils/confirm");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const notification_center_1 = require("../../../widgets/notification_center");
const table_1 = require("../../../widgets/table");
const payment_export_window_1 = require("./payment_export_window");
const payment_form_1 = require("./payment_form");
const moment = require("moment");
const REMINDER_SENT = {};
function isLate(mdl) {
    const now = moment();
    return !mdl.paid_at && moment(mdl["payments.due_at"]).isBefore(now);
}
exports.PaymentsTable = (0, table_1.createTable)({
    provider: payment_1.PaymentProvider,
    id: "paymentTable",
    title: "Paiements",
    filters: {
        "due": "En retard",
        "unpaid": "Non payé"
    },
    topMenuRight: () => {
        return (0, mithril_1.default)("a", { class: "button is-primary", onclick: () => { payment_export_window_1.PaymentExportWindow.show(); } }, (0, helpers_1.iconSpan)("fa-download", "is-small"), (0, mithril_1.default)("span", "Exporter"));
    },
    rowRenderer: (mdl, children) => {
        if (isLate(mdl)) {
            return (0, mithril_1.default)("tr", { class: "is-danger" }, children);
        }
        else {
            return (0, mithril_1.default)("tr", children);
        }
        return undefined;
    },
    actions: (mdl) => {
        let out = [];
        if (isLate(mdl) &&
            (!mdl.payment_reminded_at ||
                moment(mdl.payment_reminded_at).isBefore(moment().add(-1, "day"))) &&
            !mdl.payment_received) {
            out.push((0, mithril_1.default)("a.button.is-warning", { onclick: (evt) => {
                    evt.preventDefault();
                    app_1.App.patch(`/payments/${mdl.id}/remind`, {}).then((data) => {
                        if (data.ok) {
                            notification_center_1.Notification.info("Relance envoyé");
                        }
                        REMINDER_SENT[mdl["clients.id"]] = true;
                        exports.PaymentsTable.fetch();
                    });
                } }, (0, helpers_1.iconSpan)("fa-paper-plane"), (0, mithril_1.default)("span", "Relancer")));
        }
        out.push((0, mithril_1.default)("button.button.is-primary", {
            onclick: (evt) => { evt.preventDefault(); payment_form_1.PaymentForm.show(mdl); }
        }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Editer")));
        return out;
    },
    fields: [
        {
            name: "users.last_name",
            sortable: false,
            label: "Client",
            renderer: table_renderers_1.TableRenderers.resourceLink("clients", "show", (mdl) => mdl["clients.id"], (mdl) => `${mdl["clients.id"]} - ${mdl["clients.name"]}`)
        }, {
            name: "payments.value",
            label: "Montant",
            sortable: false,
            renderer: table_renderers_1.TableRenderers.money
        }, {
            name: "invoices.reference",
            sortable: false,
            label: "# Facture",
            renderer: table_renderers_1.TableRenderers.resourceLink("invoices", "show", (mdl) => mdl["invoices.id"], (mdl) => `${mdl["invoices.ref"]}`)
        }, {
            name: "payment_type",
            sortable: false,
            label: "Type",
            renderer: (mdl) => {
                return (0, helpers_1.tag)(payment_1.PAYMENT_TYPES[mdl.payment_type]);
            }
        }, {
            name: "payment_received",
            label: (0, mithril_1.default)("span", "Moyen de", (0, mithril_1.default)("br"), "paiements reçu"),
            sortable: false,
            renderer: table_renderers_1.TableRenderers.bool
        }, {
            name: "paid_at",
            label: "Payé le",
            sortable: false,
            renderer: table_renderers_1.TableRenderers.action((mdl) => {
                if (!mdl.paid_at) {
                    app_1.App.patch(`/payments/${mdl["payments.id"]}/pay`, {}).then(() => {
                        mdl.paid_at = moment().toISOString();
                    }).catch(() => {
                        alert("Une erreur est survenue.");
                    });
                }
                else {
                    confirm_1.Confirm.confirm("Cela va annuler la date du paiement. Etes-vous sûr de vouloir faire cela?").then(() => {
                        app_1.App.patch(`/payments/${mdl["payments.id"]}/unpay`, {}).then(() => {
                            mdl.paid_at = null;
                            mithril_1.default.redraw();
                        }).catch(() => {
                            alert("Une erreur est survenue.");
                        });
                    });
                }
            }, table_renderers_1.TableRenderers.tag(table_renderers_1.TableRenderers.maybe(table_renderers_1.TableRenderers.dateOnly, "Non payé")))
        }, {
            name: "due_at",
            label: "À payer le",
            sortable: true,
            renderer: table_renderers_1.TableRenderers.tag(table_renderers_1.TableRenderers.maybe(table_renderers_1.TableRenderers.dateOnly))
        }, {
            name: "payment_reminded_at",
            label: "Relancé le",
            sortable: true,
            renderer: table_renderers_1.TableRenderers.dateOnly
        }
    ]
});
